import { pluralize } from '@sparknz/journeys-common';

import { PaymentOption } from 'journey/productDetails/typings';

interface GetPaymentOptionsHeadingProps {
  paymentOption: PaymentOption;
  isPayUpfront: boolean;
}

const getPaymentOptionsHeading = ({
  paymentOption,
  isPayUpfront,
}: GetPaymentOptionsHeadingProps) => {
  const { priceLength, priceFrequencyPeriod } = paymentOption;

  if (isPayUpfront) return 'Pay upfront';
  return `${pluralize(
    priceLength,
    priceFrequencyPeriod.toLowerCase(),
  )} interest free`;
};

export default getPaymentOptionsHeading;
